import { Box, Text } from '@wix/design-system';
import * as React from 'react';
import { useIsMobile } from '../../../hooks';
import { useComponentsTranslations } from '../../../providers';
import { AcceptedPaymentMethodIcons } from './AcceptedPaymentMethodIcons';
import s from './AcceptedPaymentMethods.scss';
export const AcceptedPaymentMethods = ({ acceptedPaymentMethods }) => {
    const { t } = useComponentsTranslations();
    const paymentMethods = acceptedPaymentMethods;
    const isMobile = useIsMobile();
    return (React.createElement(Box, { direction: "vertical", align: isMobile ? 'center' : 'left', gap: "SP1" },
        React.createElement(Text, { weight: "bold", size: "tiny", className: s.title }, t('page_footer.accepted_payment_methods')),
        React.createElement(AcceptedPaymentMethodIcons, { paymentMethods: paymentMethods })));
};
//# sourceMappingURL=AcceptedPaymentMethods.js.map